export default __webpack_public_path__ + "static/media/MVRDV-slide-01.759bb8a2.jpg";